module.exports = __webpack_public_path__ + "images/home/orientation/no-content.e25c676458c1f4cb280b.svg";